(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["compare-slider"] && !window.DesignMode) return;
  try {
    

    const slider = document.getElementById('before-after-slider');
    const before = document.getElementById('before-image');
    const beforeImage = before.getElementsByTagName('img')[0];
    const resizer = document.getElementById('resizer');

    let active = false;

    //Sort overflow out for Overlay Image
    document.addEventListener("DOMContentLoaded", function() {
    let width = slider.offsetWidth;
    console.log(width);
    beforeImage.style.width = width + 'px';
    });

//Adjust width of image on resize 
window.addEventListener('resize', function() {
  let width = slider.offsetWidth;
  console.log(width);
  beforeImage.style.width = width + 'px';
})

resizer.addEventListener('mousedown',function(){
  active = true;
 resizer.classList.add('resize');

});

document.body.addEventListener('mouseup',function(){
  active = false;
 resizer.classList.remove('resize');
});

document.body.addEventListener('mouseleave', function() {
  active = false;
  resizer.classList.remove('resize');
});

document.body.addEventListener('mousemove',function(e){
  if (!active) return;
  let x = e.pageX;
  x -= slider.getBoundingClientRect().left;
  slideIt(x);
  pauseEvent(e);
});

resizer.addEventListener('touchstart',function(){
  active = true;
  resizer.classList.add('resize');
},{passive: true});

document.body.addEventListener('touchend',function(){
  active = false;
  resizer.classList.remove('resize');
},{passive: true});

document.body.addEventListener('touchcancel',function(){
  active = false;
  resizer.classList.remove('resize');
},{passive: true});

//calculation for dragging on touch devices
document.body.addEventListener('touchmove',function(e){
  if (!active) return;
  let x;
  
  let i;
  for (i=0; i < e.changedTouches.length; i++) {
  x = e.changedTouches[i].pageX; 
  }
  
  x -= slider.getBoundingClientRect().left;
  slideIt(x);
  pauseEvent(e);
});

function slideIt(x){
    let transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
    before.style.width = transform+"px";
    resizer.style.left = transform-0+"px";
}

//stop divs being selected.
function pauseEvent(e){
    if(e.stopPropagation) e.stopPropagation();
    if(e.preventDefault) e.preventDefault();
    e.cancelBubble=true;
    e.returnValue=false;
    return false;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();
			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
			}, 300))
		}
	}
	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();
			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
			}, 300))
		}
	}
	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-calculator"] && !window.DesignMode) return;
  try {
    

const results = document.querySelector('.calculator-results');
const options = document.querySelectorAll('.calculator-option');
const season = document.querySelector('select[name="calculator-season"]');
const application = document.querySelector('select[name="calculator-application"]');
const weight = document.querySelector('select[name="calculator-weight"]');
const volume = document.querySelector('input[name="calculator-volume"]');
const button = document.querySelector('.calculator-button');

[].forEach.call(options, function(option) {
    option.addEventListener('change', function(evt) {
        calculate();
    }, false);
})

button.addEventListener('click', function(evt) {

    results.innerHTML = '';
    
    let r = application.value; // ratio
    let o = weight.value; // ounces in metric
    let a = weight.options[weight.selectedIndex].getAttribute('data-abbr'); // abbr
    let v = volume.value; // total volume
    let t = (o*v); // volume in ounces
    let m = weight.options[weight.selectedIndex].text; // metric value

    let c = (t/r).toFixed(2);
    let d = (t-c).toFixed(2);

    if(m != 'Ounces') {
        c = (c/o).toFixed(2);
        d = (d/o).toFixed(2);
    }

    let calculatorResults;

    if(m == 'Gallons') {
        calculatorResults = [
            {'label': 'Gallons', 'abbr': 'gal', 'concentrate': c, 'water': d, 'total': c + d },
            {'label': 'Liters', 'abbr': 'l', 'concentrate': (c*3.785).toFixed(2), 'water': (d*3.785).toFixed(2), 'total': (c*3.785 + d*3.785).toFixed(2) },
            {'label': 'Quarts', 'abbr': 'qt', 'concentrate': (c*4).toFixed(2), 'water': (d*4).toFixed(2), 'total': (c*4 + d*4).toFixed(2) },
            {'label': 'Ounces', 'abbr': 'oz', 'concentrate': (c*128).toFixed(2), 'water': (d*128).toFixed(2), 'total': (c*128 + d*128).toFixed(2) }
        ];
    }
    if(m == 'Liters') {
        calculatorResults = [
            {'label': 'Liters', 'abbr': 'l', 'concentrate': c, 'water': d, 'total': c + d },
            {'label': 'Gallons', 'abbr': 'gal', 'concentrate': (c/3.785).toFixed(2), 'water': (d/3.785).toFixed(2), 'total': (c/3.785 + d/3.785).toFixed(2) },
            {'label': 'Quarts', 'abbr': 'qt', 'concentrate': (c*1.057).toFixed(2), 'water': (d*1.057).toFixed(2), 'total': (c*1.057 + d*1.057).toFixed(2) },
            {'label': 'Ounces', 'abbr': 'oz', 'concentrate': (c*33.814).toFixed(2), 'water': (d*33.814).toFixed(2), 'total': (c*33.814 + d*33.814).toFixed(2) }
        ];
    }
    if(m == 'Quarts') {
        calculatorResults = [
            {'label': 'Quarts', 'abbr': 'qt', 'concentrate': c, 'water': d, 'total': c + d },
            {'label': 'Gallons', 'abbr': 'gal', 'concentrate': (c/4).toFixed(2), 'water': (d/4).toFixed(2), 'total': (c/4 + d/4).toFixed(2) },
            {'label': 'Liters', 'abbr': 'l', 'concentrate': (c/1.057).toFixed(2), 'water': (d/1.057).toFixed(2), 'total': (c/1.057 + d/1.057).toFixed(2) },
            {'label': 'Ounces', 'abbr': 'oz', 'concentrate': (c*32).toFixed(2), 'water': (d*32).toFixed(2), 'total': (c*32 + d*32).toFixed(2) }
        ];
    }
    if(m == 'Ounces') {
        calculatorResults = [
            {'label': 'Ounces', 'abbr': 'oz', 'concentrate': c, 'water': d, 'total': c + d },
            {'label': 'Gallons', 'abbr': 'gal', 'concentrate': (c*0.0078125).toFixed(2), 'water': (d*0.0078125).toFixed(2), 'total': (c*0.0078125 + d*0.0078125).toFixed(2)},
            {'label': 'Liters', 'abbr': 'l', 'concentrate': (c*0.0295735).toFixed(2), 'water': (d*0.0295735).toFixed(2), 'total': (c*0.0295735 + d*0.0295735).toFixed(2) },
            {'label': 'Quarts', 'abbr': 'qt', 'concentrate': (c*0.03125).toFixed(2), 'water': (d*0.03125).toFixed(2), 'total': (c*0.03125 + d*0.03125).toFixed(2) }
        ];
    }
  
    let waterResults = document.createElement('div');
    let waterConversions = document.createElement('div');
    let waterPercentage = Math.round((parseInt(calculatorResults[0]['water']) / v) * 100);
    if(waterPercentage <= 0) {
        waterPercentage = 90;
    }
    waterResults.innerHTML = '<div class="calculator-results--amount"><div><div class="loader"><span style="height:' + waterPercentage + '%"></span></div><svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="46.00604" height="79.5" viewBox="0 0 46.00604 79.5"><g id="Layer_1-2" data-name="Layer 1"><g><path d="m43.95294,37.5097l-6.28851-9.71185c-.53326-.98566-1.5257-1.59393-2.60059-1.59393h-13.0957c-1.03729,0-2.00073.56683-2.54675,1.49835l-5.94525,9.62134c-1.52521,2.60229-2.33325,5.60217-2.33325,8.66272v29.73108c0,2.08905,1.60345,3.78259,3.58142,3.78259h27.70032c1.97797,0,3.58142-1.69354,3.58142-3.78259v-30.04236c0-2.86407-.7077-5.67859-2.0531-8.16534Z" style="fill: #dff4f1;"/><path d="m23.21729,14.21228h3.16644v3.55304l-4.87341.00006c-.76825,0-1.39105.6228-1.39105,1.39111v3.86163c0,.28772.23328.52094.521.52094h15.03223c.29199,0,.52869-.23669.52869-.52863v-3.854c0-.76831-.6228-1.39111-1.39105-1.39111h-4.87335v-3.55304h3.16644c2.4201,0,4.38202-1.8587,4.38202-4.15143v-5.90955c0-2.29272-1.96191-4.15131-4.38202-4.15131h-9.88593c-2.4201,0-4.38202,1.85858-4.38202,4.15131v5.90955c0,2.29272,1.96191,4.15143,4.38202,4.15143Zm-1.52502-8.47638c0-1.31543.94244-2.38184,2.10498-2.38184h8.72601c1.16254,0,2.10492,1.06641,2.10492,2.38184v2.93616c0,1.31555-.94238,2.38196-2.10492,2.38196h-8.72601c-1.16254,0-2.10498-1.06641-2.10498-2.38196v-2.93616Z" style="fill: #dff4f1;"/><path d="m10.15417,11.95819c-.19604-.12317-.33099-.2558-.45349-.06061l-.54285.86456c-.31818-.13367-.61829-.16815-.73346-.00171l-2.242,2.75372c-.59125.84741-.54138.89362.67914,1.63525.99841.60675,1.32501,1.16565,1.79797.0423l1.44452-3.19952c.16058-.22748.01526-.51917-.24573-.77313l.55054-.87671c.12299-.19562-.05902-.26147-.25464-.38416Z" style="fill: #dff4f1;"/><path d="m3.68127,69.55328h.90173c.54608,0,.9928-.44678.9928-.9928v-21.83356c0-.54602-.44672-.99274-.9928-.99274h-.52032c.08777-1.77417.19611-4.96869.19611-10.03937,0-.88025-.02142-1.72986-.0423-2.54639-.03815-1.46851-.0733-2.85541.03693-4.05487.60199-6.52106,2.78394-9.71173,2.82983-9.77789.4483-.49109-1.87665-1.79071-1.98407-1.4223-.10608.14752-2.60449,3.69159-3.27618,10.97614-.12396,1.34247-.08643,2.79907-.04712,4.34149.02026.79626.04175,1.62531.04175,2.48383,0,5.11023-.11066,8.29718-.19861,10.03937h-.62628c-.54602,0-.99274.44672-.99274.99274v21.83356c0,.54602.44672.9928.99274.9928h.68854c.01123.87488.21484,2.62012,1.51428,4.07855,1.33594,1.49805,3.41016,2.25781,6.16602,2.25781v-2c-2.14941,0-3.7168-.52881-4.6582-1.57227-.87622-.97095-1.01129-2.18817-1.02209-2.7641Z" style="fill: #ddedea;"/></g></g></svg></div><div><div class="t--xs c--jade t--upper"><span class="t--medium">Step 1: Add Water</span> (' + calculatorResults[0]['label'] + ')</div><div class="h--md t--semi">' + calculatorResults[0]['water'] + '</div></div>';
    for (let step = 1; step < calculatorResults.length; step++) {
        waterConversions.innerHTML += '<div class="subitem"><span>' + calculatorResults[step]['label'] + '</span>' + calculatorResults[step]['water'] + '</div>';
    }
    waterResults.appendChild(waterConversions);
    waterResults.classList.add('calculator-results--col','step1');
    waterConversions.classList.add('calculator-results--conversions');
    results.appendChild(waterResults);
    
    let concentrateResults = document.createElement('div');
    let concentrateConversions = document.createElement('div');
    let concentratePercentage = Math.round((parseInt(calculatorResults[0]['concentrate']) / v) * 100);
    if(concentratePercentage <= 0) {
        concentratePercentage = 10;
    }
    concentrateResults.innerHTML = '<div class="calculator-results--amount"><div><div class="loader"><span style="height:' + concentratePercentage + '%"></span></div><svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="46.00604" height="79.5" viewBox="0 0 46.00604 79.5"><g id="Layer_1-2" data-name="Layer 1"><g><path d="m43.95294,37.5097l-6.28851-9.71185c-.53326-.98566-1.5257-1.59393-2.60059-1.59393h-13.0957c-1.03729,0-2.00073.56683-2.54675,1.49835l-5.94525,9.62134c-1.52521,2.60229-2.33325,5.60217-2.33325,8.66272v29.73108c0,2.08905,1.60345,3.78259,3.58142,3.78259h27.70032c1.97797,0,3.58142-1.69354,3.58142-3.78259v-30.04236c0-2.86407-.7077-5.67859-2.0531-8.16534Z" style="fill: #dff4f1;"/><path d="m23.21729,14.21228h3.16644v3.55304l-4.87341.00006c-.76825,0-1.39105.6228-1.39105,1.39111v3.86163c0,.28772.23328.52094.521.52094h15.03223c.29199,0,.52869-.23669.52869-.52863v-3.854c0-.76831-.6228-1.39111-1.39105-1.39111h-4.87335v-3.55304h3.16644c2.4201,0,4.38202-1.8587,4.38202-4.15143v-5.90955c0-2.29272-1.96191-4.15131-4.38202-4.15131h-9.88593c-2.4201,0-4.38202,1.85858-4.38202,4.15131v5.90955c0,2.29272,1.96191,4.15143,4.38202,4.15143Zm-1.52502-8.47638c0-1.31543.94244-2.38184,2.10498-2.38184h8.72601c1.16254,0,2.10492,1.06641,2.10492,2.38184v2.93616c0,1.31555-.94238,2.38196-2.10492,2.38196h-8.72601c-1.16254,0-2.10498-1.06641-2.10498-2.38196v-2.93616Z" style="fill: #dff4f1;"/><path d="m10.15417,11.95819c-.19604-.12317-.33099-.2558-.45349-.06061l-.54285.86456c-.31818-.13367-.61829-.16815-.73346-.00171l-2.242,2.75372c-.59125.84741-.54138.89362.67914,1.63525.99841.60675,1.32501,1.16565,1.79797.0423l1.44452-3.19952c.16058-.22748.01526-.51917-.24573-.77313l.55054-.87671c.12299-.19562-.05902-.26147-.25464-.38416Z" style="fill: #dff4f1;"/><path d="m3.68127,69.55328h.90173c.54608,0,.9928-.44678.9928-.9928v-21.83356c0-.54602-.44672-.99274-.9928-.99274h-.52032c.08777-1.77417.19611-4.96869.19611-10.03937,0-.88025-.02142-1.72986-.0423-2.54639-.03815-1.46851-.0733-2.85541.03693-4.05487.60199-6.52106,2.78394-9.71173,2.82983-9.77789.4483-.49109-1.87665-1.79071-1.98407-1.4223-.10608.14752-2.60449,3.69159-3.27618,10.97614-.12396,1.34247-.08643,2.79907-.04712,4.34149.02026.79626.04175,1.62531.04175,2.48383,0,5.11023-.11066,8.29718-.19861,10.03937h-.62628c-.54602,0-.99274.44672-.99274.99274v21.83356c0,.54602.44672.9928.99274.9928h.68854c.01123.87488.21484,2.62012,1.51428,4.07855,1.33594,1.49805,3.41016,2.25781,6.16602,2.25781v-2c-2.14941,0-3.7168-.52881-4.6582-1.57227-.87622-.97095-1.01129-2.18817-1.02209-2.7641Z" style="fill: #ddedea;"/></g></g></svg></div><div><div class="t--xs c--jade t--upper"><span class="t--medium">Step 2: Add Wilt-Pruf</span> (' + calculatorResults[0]['label'] + ')</div><div class="h--md t--semi">' + calculatorResults[0]['concentrate'] + '</div></div>';
    for (let step = 1; step < calculatorResults.length; step++) {
        concentrateConversions.innerHTML += '<div class="subitem"><span>' + calculatorResults[step]['label'] + '</span>' + calculatorResults[step]['concentrate'] + '</div>';
    }
    concentrateResults.appendChild(concentrateConversions);
    concentrateResults.classList.add('calculator-results--col','step2');
    concentrateConversions.classList.add('calculator-results--conversions');
    results.appendChild(concentrateResults);

    let totalResults = document.createElement('div');
    let totalConversions = document.createElement('div');
    totalResults.innerHTML = '<div class="calculator-results--amount total"><div><div class="loader"><span style="height:' + concentratePercentage + '%"></span></div><svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="46.00604" height="79.5" viewBox="0 0 46.00604 79.5"><g id="Layer_1-2" data-name="Layer 1"><g><path d="m43.95294,37.5097l-6.28851-9.71185c-.53326-.98566-1.5257-1.59393-2.60059-1.59393h-13.0957c-1.03729,0-2.00073.56683-2.54675,1.49835l-5.94525,9.62134c-1.52521,2.60229-2.33325,5.60217-2.33325,8.66272v29.73108c0,2.08905,1.60345,3.78259,3.58142,3.78259h27.70032c1.97797,0,3.58142-1.69354,3.58142-3.78259v-30.04236c0-2.86407-.7077-5.67859-2.0531-8.16534Z" style="fill: #dff4f1;"/><path d="m23.21729,14.21228h3.16644v3.55304l-4.87341.00006c-.76825,0-1.39105.6228-1.39105,1.39111v3.86163c0,.28772.23328.52094.521.52094h15.03223c.29199,0,.52869-.23669.52869-.52863v-3.854c0-.76831-.6228-1.39111-1.39105-1.39111h-4.87335v-3.55304h3.16644c2.4201,0,4.38202-1.8587,4.38202-4.15143v-5.90955c0-2.29272-1.96191-4.15131-4.38202-4.15131h-9.88593c-2.4201,0-4.38202,1.85858-4.38202,4.15131v5.90955c0,2.29272,1.96191,4.15143,4.38202,4.15143Zm-1.52502-8.47638c0-1.31543.94244-2.38184,2.10498-2.38184h8.72601c1.16254,0,2.10492,1.06641,2.10492,2.38184v2.93616c0,1.31555-.94238,2.38196-2.10492,2.38196h-8.72601c-1.16254,0-2.10498-1.06641-2.10498-2.38196v-2.93616Z" style="fill: #dff4f1;"/><path d="m10.15417,11.95819c-.19604-.12317-.33099-.2558-.45349-.06061l-.54285.86456c-.31818-.13367-.61829-.16815-.73346-.00171l-2.242,2.75372c-.59125.84741-.54138.89362.67914,1.63525.99841.60675,1.32501,1.16565,1.79797.0423l1.44452-3.19952c.16058-.22748.01526-.51917-.24573-.77313l.55054-.87671c.12299-.19562-.05902-.26147-.25464-.38416Z" style="fill: #dff4f1;"/><path d="m3.68127,69.55328h.90173c.54608,0,.9928-.44678.9928-.9928v-21.83356c0-.54602-.44672-.99274-.9928-.99274h-.52032c.08777-1.77417.19611-4.96869.19611-10.03937,0-.88025-.02142-1.72986-.0423-2.54639-.03815-1.46851-.0733-2.85541.03693-4.05487.60199-6.52106,2.78394-9.71173,2.82983-9.77789.4483-.49109-1.87665-1.79071-1.98407-1.4223-.10608.14752-2.60449,3.69159-3.27618,10.97614-.12396,1.34247-.08643,2.79907-.04712,4.34149.02026.79626.04175,1.62531.04175,2.48383,0,5.11023-.11066,8.29718-.19861,10.03937h-.62628c-.54602,0-.99274.44672-.99274.99274v21.83356c0,.54602.44672.9928.99274.9928h.68854c.01123.87488.21484,2.62012,1.51428,4.07855,1.33594,1.49805,3.41016,2.25781,6.16602,2.25781v-2c-2.14941,0-3.7168-.52881-4.6582-1.57227-.87622-.97095-1.01129-2.18817-1.02209-2.7641Z" style="fill: #ddedea;"/></g></g></svg></div><div><div class="t--xs c--jade t--upper"><span class="t--medium">Total Application</span> (' + calculatorResults[0]['label'] + ')</div><div class="h--md t--semi">' + v + '</div></div>';
    for (let step = 1; step < calculatorResults.length; step++) {
        totalConversions.innerHTML += '<div class="subitem"><span>' + calculatorResults[step]['label'] + '</span>' + calculatorResults[step]['total'] + '</div>';
    }
    totalResults.appendChild(totalConversions);
    totalResults.classList.add('calculator-results--col','final');
    totalConversions.classList.add('calculator-results--conversions');
    results.appendChild(totalResults);
    results.parentNode.classList.remove('hidden');

}, false);

function calculate() {

    let opt1 = season.value,
        opt2 = application.value,
        opt3 = weight.value,
        opt4 = volume.value;

    if(opt1) {
        application.disabled = false;
    }
    if(opt2) {
        weight.disabled = false;
    }
    if(opt3) {
        volume.disabled = false;
        button.disabled = false;
    }

}

volume.addEventListener('keyup', function onEvent(e) {
    if (e.keyCode === 13) {
        button.click();
    }
});


  } catch(e) { console.error(e); }
})();
      })();
